/**
 * REACT_APP_HDMI_CONNECTED_ONLY
 *   true  (default) — list HDMI ports with an active signal (skip signal === false)
 *   false — list every HDMI port on the TV (connected + disconnected)
 *
 * REACT_APP_HDMI_DEFAULT_PREVIEW
 *   true  — mock HDMI in browser/default device (Settings UI dev)
 *   false — never mock on default (overrides connected-only auto-preview)
 *   unset — auto: preview on default when HDMI_CONNECTED_ONLY=false
 */
export function isHdmiConnectedOnlyMode() {
  var value = process.env.REACT_APP_HDMI_CONNECTED_ONLY;
  if (value === undefined || value === '') {
    return true;
  }
  return value === 'true';
}

export function isHdmiDefaultPreviewEnabled() {
  var preview = process.env.REACT_APP_HDMI_DEFAULT_PREVIEW;
  if (preview === 'false') {
    return false;
  }
  if (preview === 'true') {
    return true;
  }
  return !isHdmiConnectedOnlyMode();
}
